import { parseDate, type DateRangeFilter } from '@talos/kyoko';
import { isAfter, isBefore } from 'date-fns';
import { getDefaultCareOrderTimestampField, type CareOrderTimestampField } from './careOrderTimestampFields';

interface CareOrderDateRangeEntity {
  SubmitTime: string;
  Timestamp: string;
  isComplete: boolean;
}

function getDatesByTimestampField(
  entity: CareOrderDateRangeEntity,
  timestampField: CareOrderTimestampField | undefined
) {
  const selectedTimestampField = timestampField ?? getDefaultCareOrderTimestampField();
  if (selectedTimestampField != null) {
    return [parseDate(entity[selectedTimestampField])];
  }
  return [parseDate(entity.Timestamp)];
}

export function passesCareOrderDateRangeFilter(
  entity: CareOrderDateRangeEntity,
  filter: DateRangeFilter<CareOrderTimestampField>,
  includeOpenCareOrdersOutsideDateRange = true
) {
  const startDate = filter.StartDate == null ? undefined : parseDate(filter.StartDate);
  const endDate = filter.EndDate == null ? undefined : parseDate(filter.EndDate);
  const dates = getDatesByTimestampField(entity, filter.TimestampField);

  const shouldBypassStartDateFilter = includeOpenCareOrdersOutsideDateRange && endDate == null && !entity.isComplete;

  if (startDate != null && !shouldBypassStartDateFilter && dates.every(date => isBefore(date, startDate))) {
    return false;
  }

  if (endDate != null && dates.every(date => isAfter(date, endDate))) {
    return false;
  }

  return true;
}
